<app-not-found [path]="path"></app-not-found>
